var _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirdieFallinginline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fallingbird",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "motionBlur"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.4,
    y1: 523.1,
    x2: 76.4,
    y2: 636.5,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CDBFA2",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#C0A598",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#B48E8F",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#AB7B87",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#A36C81",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#9E627D",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#9B5C7B",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.8,
    y: 33.1,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)",
      enableBackground: "new"
    },
    width: 5.2,
    height: 113.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.5,
    y1: 523.1,
    x2: 98.5,
    y2: 636.5,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CDBFA2",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#C0A598",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#B48E8F",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#AB7B87",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#A36C81",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#9E627D",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#9B5C7B",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 33.1,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_2_)",
      enableBackground: "new"
    },
    width: 2.6,
    height: 113.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.4,
    y1: 535.7,
    x2: 116.4,
    y2: 636.5,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CDBFA2",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#C0A598",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#B48E8F",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#AB7B87",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#A36C81",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#9E627D",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#9B5C7B",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 45.7,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_3_)",
      enableBackground: "new"
    },
    width: 8.2,
    height: 100.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.95,
    y1: 618,
    x2: 39.95,
    y2: 709.4,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#CFBCA0",
      stopOpacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#D2AF99",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#D4A393",
      stopOpacity: 0.49
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D69A8E",
      stopOpacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#D7928A",
      stopOpacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#D88C87",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#D98785",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#DA8583",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA8483"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 128,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_4_)",
      enableBackground: "new"
    },
    width: 7.3,
    height: 91.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.9,
    y1: 554.7,
    x2: 284.9,
    y2: 647.1,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D1C3A4",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#D6C5A4",
      stopOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#DBC8A5",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#DFCAA6",
      stopOpacity: 0.67
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#E2CBA6",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#E4CCA7",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#E6CDA7",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#E7CEA7",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7CEA7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 283.6,
    y: 64.7,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_5_)",
      enableBackground: "new"
    },
    width: 2.6,
    height: 92.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6,
    y1: 576.7,
    x2: 58.6,
    y2: 729.7,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#CEBDA1",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#D0B09A",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#D1A494",
      stopOpacity: 0.47
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D29A8F",
      stopOpacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#D3928A",
      stopOpacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#D48C87",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#D58785",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D58583",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D58483"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 86.7,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_6_)",
      enableBackground: "new"
    },
    width: 3,
    height: 153
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.8,
    y1: 523.1,
    x2: 138.8,
    y2: 636.5,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CDBFA2",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#C0A598",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#B48E8F",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#AB7B87",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#A36C81",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#9E627D",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#9B5C7B",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.2,
    y: 33.1,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_7_)",
      enableBackground: "new"
    },
    width: 5.2,
    height: 113.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.3,
    y1: 523.1,
    x2: 158.3,
    y2: 636.5,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CDBFA2",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#C0A598",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#B48E8F",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#AB7B87",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#A36C81",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#9E627D",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#9B5C7B",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 33.1,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_8_)",
      enableBackground: "new"
    },
    width: 2.6,
    height: 113.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.6,
    y1: 596.6,
    x2: 176.6,
    y2: 692.2,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#D6C7A5",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#DECDA7",
      stopOpacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E5D2A8",
      stopOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#EBD6AA",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F0DAAB",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#F3DDAC",
      stopOpacity: 0.89
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#F6DFAD",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#F8E0AD",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8E0AD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 106.6,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_9_)",
      enableBackground: "new"
    },
    width: 5.2,
    height: 95.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.45,
    y1: 549.6,
    x2: 207.45,
    y2: 652.9,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#CFBDA1",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#D1B09A",
      stopOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#D4A494",
      stopOpacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D69A8F",
      stopOpacity: 0.64
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#D7928A",
      stopOpacity: 0.77
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#D88C87",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#D98785",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#DA8583",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#DA8483"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#CB7A81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#B56C7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#A6627C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#9D5C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 59.6,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_10_)",
      enableBackground: "new"
    },
    width: 2.7,
    height: 103.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.1,
    y1: 573.5,
    x2: 240.1,
    y2: 657.1,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D1C3A4",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#D6C5A4",
      stopOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#DBC8A5",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#DFCAA6",
      stopOpacity: 0.67
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#E2CBA6",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#E4CCA7",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#E6CDA7",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#E7CEA7",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7CEA7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 83.5,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_11_)",
      enableBackground: "new"
    },
    width: 8.2,
    height: 83.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 266,
    y1: 555.4,
    x2: 266,
    y2: 646.4,
    gradientTransform: "matrix(1 0 0 1 0 -490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D1C3A4",
      stopOpacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#D6C5A4",
      stopOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#DBC8A5",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#DFCAA6",
      stopOpacity: 0.67
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#E2CBA6",
      stopOpacity: 0.79
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#E4CCA7",
      stopOpacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#E6CDA7",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#E7CEA7",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7CEA7"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 264.7,
    y: 65.4,
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_12_)",
      enableBackground: "new"
    },
    width: 2.6,
    height: 91
  })), /*#__PURE__*/React.createElement("path", {
    id: "backFeet",
    style: {
      fill: "#E4BEBD"
    },
    d: "M189.5,184.9l1.8-10c0,0-5.8-5.3-6.4-18.7c-0.6-13,0.8-16.4,4.2-19.3s9.8-1,9.8-1 s-5.8,3.7-6.2,8.1c-0.4,4.1-2,14.4,0.1,17.2c1.4,1.8,3.2,3.1,5.3,3.9c0,0,2.7-1.4,4-6.2s-2.1-5.8-2.1-5.8s6.6,0.8,6.8,4 s0.4,12-3.9,15.8s-5.9,4.6-5.9,4.6l-1.1,11.5L189.5,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "backLeg",
    style: {
      fill: "#CEC1A3"
    },
    d: "M179.7,205.4c-0.2-3.4,0.6-6.7,2.2-9.6c2.2-4,4.7-7.8,7.4-11.5l5.6,0.5 c0,0,0.4,9.6-2.4,14.5S179.7,205.4,179.7,205.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backWing_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -660.0402,
    y1: 1023.4977,
    x2: -523.3795,
    y2: 887.8563,
    gradientTransform: "matrix(0.49 -0.81 0.71 0.38 -285.33 -692.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#C1A799"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B38B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#A87585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#A0667F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#9B5D7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "backWing",
    style: {
      fill: "url(#backWing_1_)"
    },
    d: "M114.1,231.3c-16.2-6.8-40.7-41.4-43-47.5s-5.7-26.2-5.2-50.5 s13.5-61,13.5-61s28.1,17.1,35.8,32.6c11.7,23.4,4.4,46.9,4.4,46.9s15.6,9.1,22.4,20.8c7,12.1,9.2,22.6,7.7,30 S122.3,234.3,114.1,231.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "body_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.8121,
    y1: -190.7354,
    x2: 77.8121,
    y2: -310.7754,
    gradientTransform: "matrix(0.99 -0.17 -0.15 -0.89 61.06 -11.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#E3D5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F3E5BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FCEEC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body",
    style: {
      fill: "url(#body_1_)"
    },
    d: "M62.4,235.6c0,0,2,40.4,73.9,25.5c55.8-11.6,53.1-34.3,70.2-43.2s79-54.9,79-54.9 s7.4-7.5-3-17.5s-34.8-13-34.8-13s-27.9,62.9-38.3,63.8s-38.3,4.6-62.4,5.9C122,203.7,55.4,195.2,62.4,235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontFeet",
    style: {
      fill: "#FBCCCC"
    },
    d: "M198.6,183l1.2-10.1c0,0-6.1-5-7.4-18.3c-1.2-12.9-0.1-16.4,3.2-19.5s9.7-1.5,9.7-1.5 s-5.6,4-5.8,8.4c-0.2,4.1-1.3,14.5,1.1,17.2c1.5,1.7,3.4,2.9,5.5,3.6c0,0,2.6-1.5,3.7-6.4s-2.4-5.7-2.4-5.7s6.6,0.4,7,3.6 s1,11.9-3.1,16s-5.6,4.9-5.6,4.9l-0.5,11.5L198.6,183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontLeg",
    style: {
      fill: "#EADEBB"
    },
    d: "M192,199.7c0,0-2-0.1,0.3-6.4c1.9-4.8,4.1-9.4,6.6-13.9l6.9,0.3c0,0,1.6,13.9-0.9,19.8 S192,199.7,192,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head",
    style: {
      fill: "#DA8483"
    },
    d: "M84.8,260.6c6.7,2.8,23.6,6.3,33.7-19.5s-8.7-38.8-8.7-38.8s-9-2.4-35.6-5 c-12.5-1.2-33,2-37.2,16.5C31.6,232.1,78.1,257.9,84.8,260.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frontWing_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -209.0763,
    y1: 948.6108,
    x2: -209.0763,
    y2: 785.9608,
    gradientTransform: "matrix(0.78 -0.63 0.5 0.66 -131.72 -529.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF2CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#FDEFC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E3C8B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#CCA6A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#BA8A93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#AC7588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#A26680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#9C5D7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "frontWing",
    style: {
      fill: "url(#frontWing_1_)"
    },
    d: "M121.9,248.8c-13.5-13.3-25.3-56.6-25.4-63.3s3.6-27.3,12.7-50 s34.8-52,34.8-52s21.6,28.2,23.7,46.1c1.8,16.4-2.6,32.9-12.2,46.3c0,0,12.1,15.2,14.7,29.2c2.6,14.4,1,25.4-3.1,31.7 S128.9,255.1,121.9,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beakLow",
    style: {
      fill: "#DBBD7A"
    },
    d: "M48.5,205.9l5.9-1.9c-0.3-2.7-0.1-5.4,0.8-7.9c1.5-3.8,2.5-3.2,2.5-3.2s-5-0.4-6.9,2.9 S48.5,205.9,48.5,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beak",
    style: {
      fill: "#FFDE8D"
    },
    d: "M54.3,204.1c0,0,0.5,2.9-3.8,5.2s-7.6,0.1-9.3-2.5c-2.8-3.9-3.2-9-1.1-13.3 c2.9-6,14.6-1.9,14.6-1.9s-11.1,0.2-5.8,6.4L54.3,204.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "eye-2",
    cx: 49.2,
    cy: 219.5,
    r: 5.8
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "eyeShine",
    transform: "matrix(0.9856 -0.1693 0.1693 0.9856 -36.1859 11.2165)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.7,
    cy: 217.8,
    rx: 1.8,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DA8483"
    },
    points: "42.3,213.6 55.1,229.4 42.3,225.3 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdieFallinginline);
export default __webpack_public_path__ + "static/media/birdie-falling.inline.0d38feab22d6e4008bf0c93f9c2d60a1.svg";
export { ForwardRef as ReactComponent };